import React from "react";
import SalesListHeaderBoxValue from "./SalesListHeaderBoxValue";

const SalesListAllHeader = props => {
	return (
		<div className="sales-list-header__boxes__content__values__block-of-status-contents">
			<SalesListHeaderBoxValue
				value={props.valueTotalToReceive}
				isFetching={props.isFetching}
				title="Pagamentos previstos:"
			/>
			<SalesListHeaderBoxValue
				value={props.valueTotalReceived}
				isFetching={props.isFetching}
				title="Pagamentos efetuados:"
			/>
			<SalesListHeaderBoxValue
				value={props.valueTotalFrozen}
				isFetching={props.isFetching}
				title="Pagamentos congelados:"
			/>
			<SalesListHeaderBoxValue
				value={props.totalMiles}
				isDecimal={true}
				isFetching={props.isFetching}
				title="Milhas vendidas:"
			/>
		</div>
	);
};

export default SalesListAllHeader;
